import React from "react";
import "./_opc-lock-tags.scss";

// "Edited after lock" / "Added after lock" markers (BE 2.7 flags, CD24) —
// small grey tags, on team cards and the plan header.
const OpcLockTags = ({ flags }) => {
  if (!flags) return null;
  const tags = [];
  if (flags.added_after_lock) tags.push("Added after lock");
  else if (flags.edited_after_lock) tags.push("Edited after lock");
  if (flags.no_activity) tags.push("No activity");
  return tags.length ? (
    <>
      {tags.map((t) => (
        <span className="opc-tag" key={t}>
          {t}
        </span>
      ))}
    </>
  ) : null;
};

export default OpcLockTags;
